/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DescriptiveBusinessObjectFormatUpdateRequest { 
    /**
     * The Usage of this Business Object Format - a string describing how this format is used. Often used as a label for the Business                   Object Format                
     */
    businessObjectFormatUsage: string;
    /**
     * The File type for this Business Object Definition
     */
    businessObjectFormatFileType: string;
}
